import Model from "~/models/_Model";

export default class Student extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/eschoolplus/registration";
  }

  // Set the resource route of the model
  resource() {
    return "students";
  }

  primaryKey() {
    return "STUDENT_ID";
  }

  getPrimaryKey() {
    return this[this.primaryKey()];
  }

  relations() {
    return {
      //timesheets: Timesheet,
    };
  }

  // Computed Attributes
  get building_name() {
    if (this.building && this.building.NAME) {
      return this.building.NAME;
    }
    switch (this.BUILDING) {
      case "100":
      case 100:
        return "East Leyden High School";
      case "200":
      case 200:
        return "West Leyden High School";
      case "300":
      case 300:
        return "LIFE Program";
      default:
        return this.BUILDING;
    }
  }

  get display_picture_url() {
    if (this.picture_url) {
      return this.picture_url.replace("//mylhs", "//app-mylhs") + "?appId=1";
    }
    //https://app-mylhs.leyden212.org/esp/students/image/20000
    return "/person.jpg";
  }
}
